import { Component } from '@angular/core';

@Component({
  selector: 'app-info-conc-juvenil-2024',
  imports: [],
  templateUrl: './info-conc-juvenil-2024.html',
  styleUrl: './info-conc-juvenil-2024.scss'
})
export class InfoConcJuvenil2024 {

}
